var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"approveCard"},[_c('div',{staticClass:"approveCard-left"},[_vm._v("企业法人认证")]),_c('div',{staticClass:"approveCard-right",on:{"click":_vm.toPage}},[_vm._v(" 认证享受完整权益 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }